import { render, staticRenderFns } from "./MenuUser.vue?vue&type=template&id=49084e0c&scoped=true"
import script from "./MenuUser.vue?vue&type=script&lang=js"
export * from "./MenuUser.vue?vue&type=script&lang=js"
import style0 from "./MenuUser.vue?vue&type=style&index=0&id=49084e0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49084e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49084e0c')) {
      api.createRecord('49084e0c', component.options)
    } else {
      api.reload('49084e0c', component.options)
    }
    module.hot.accept("./MenuUser.vue?vue&type=template&id=49084e0c&scoped=true", function () {
      api.rerender('49084e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuUser.vue"
export default component.exports